import React from "react";

const InputSuccess = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <circle cx="9.00002" cy="9.00002" r="7.6" stroke="#41B661" />
      <path
        d="M13.0022 5.922L7.23831 11.9716L5.11206 9.84535"
        stroke="#41B661"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default InputSuccess;
